module.exports = __webpack_public_path__ + "img/Edit_tutorial.75c70997.png";